// 仓位类型
// ! 1: 逐仓
// ! 2: 全仓
export const SPOT_TYPE = {
    TYPE_DEFAULT: 'spot', //现货
    TYPE_ISOLATED: 'isolated',
    TYPE_CROSS: 'cross'
}
// 现货ws订阅定义
export const WS_SUBSCRIBE_TYPE = {
    TYPE_TICKERALL: 'tickerAll',
    TYPE_TICKERS_GROUP: 'tickersGroup',
    TYPE_COIN_PRICE: 'coinPrice',
    TYPE_ACCOUNT: 'account',
    TYPE_TRADE: 'trade',
    TYPE_BOOKS15: 'depth25',
    TYPE_MARKET_DEPTH: 'depth50',
    TYPE_CURRENT_ENTRUSTS: 'currentEntrusts',
    TYPE_CURRENT_PLANS: 'currentPlans',
    TYPE_HISTORY_ENTRUSTS: 'historyEntrusts', // 历史 市价 限价
    TYPE_HISTORY_PLANS: 'historyPlans', // 历史计划委托
    TYPE_ACCOUNT_DEAL: 'userAccountDeal', // 现货明细
    TYPE_OCO_CURRENT_ENTRUSTS: 'ocoCurrentEntrusts',
    TYPE_TPSL_ENTRUST: 'tpslEntrust',
    TYPE_HISTORY_TPSL: 'tpslHistoryEntrust',
    TYPE_HISTORY_TRACK: 'hisTrackPlan',
    TYPE_CUR_TRACK_PLAN: 'curTrackPlan',

    //新增杠杆ws定义
    TYPE_CROSS_ACCOUNT: 'crossAssets',
    TYPE_ISOLATE_ACCOUNT: 'isolateAssets',
    TYPE_CROSS_CURRENT_ENTRUSTS: 'crossCurrentEntrusts',
    TYPE_ISOLATE_CURRENT_ENTRUSTS: 'isolateCurrentEntrusts',
    TYPE_CROSS_HISTORY_ENTRUSTS: 'crossHistoryEntrusts', // 全仓历史委托
    TYPE_ISOLATE_HISTORY_ENTRUSTS: 'isolateHistoryEntrusts', // 逐仓历史委托
    TYPE_CROSS_ACCOUNT_DEAL: 'crossUserAccountDeal', // 全仓成交明细
    TYPE_ISOLATE_ACCOUNT_DEAL: 'isolateUserAccountDeal', // 逐仓成交明细
    TYPE_INDEX_PRICE: 'indexPrice',
    TYPE_CROSS_TPSL: 'crossTpslEntrust',
    TYPE_CROSS_TPSL_HISTORY: 'crossTpslHistoryEntrust',
    TYPE_ISOLATE_TPSL_CURRENT: 'isolateTpslEntrust',
    TYPE_ISOLATE_TPSL_HISTORY: 'isolateTpslHistoryEntrust',

    //
    TYPE_OCO_CROSS_CURRENT_ENTRUSTS: 'ocoCrossCurrentEntrusts', //全仓当前委托
    TYPE_OCO_ISOLATE_CURRENT_ENTRUSTS: 'ocoIsolateCurrentEntrusts', //全仓当前委托

    //
    TYPE_CURRENT_TRACE_ORDERS: 'currentTraceOrders', //现货带单
    TYPE_ISOLATED_POSITION: 'isolatePosition', // 逐仓仓位 新功能 仓位盈亏

    TYPE_SPOT_TICKERS: 'tickers', // BBO新加的ticker

    // C2C
    TYPE_C2C_TICKER: 'c2cTicker',
    TYPE_C2C_TRADE: 'c2cTrade',
    TYPE_C2C_DEPTH: 'c2cDepth',
    // C2C 盘前交易
    TYPE_C2C_PRE_TICKER: 'c2cPreTicker',
    TYPE_C2C_PRE_TRADE: 'c2cPreTrade',
    TYPE_C2C_PRE_DEPTH: 'c2cPreDepth',
    /** C2C 盘前交易-订单深度 */
    TYPE_C2C_PRE_ORDER_DEPTH: 'c2cPreOrderDepth',

    // 集合竞价
    TYPE_CALL_AUCTION: 'callAuction'
}

// 现货订阅action定义
export const WS_SUBSCRIBE_ACTION = {
    ACTION_SNAPSHOT: 'snapshot',
    ACTION_UPDATE: 'update'
}

/**
 * 现货跟单 明细/汇总tab
 */
export const SPOT_TACE_TAB = {
    DETAIL_TYPE: 'detail', // 明细
    SUMMARY_TYPE: 'summary' // 汇总
}

/**
 * 一键撤销类型
 *  止盈止损 0
 *  止盈 1
 *  止损 2
 */

export enum CANCEL_TYPE {
    ProfitLoss = 0,
    Profit = 1,
    Loss = 2
}

export const CANCEL_MESSAGE = {
    [CANCEL_TYPE.ProfitLoss]: 'condition_block.cancel_all_noProfit_loss',
    [CANCEL_TYPE.Profit]: 'condition_block.cancel_all_noProfit',
    [CANCEL_TYPE.Loss]: 'condition_block.cancel_all_noLoss'
}
